// Formatos en español de Ecuador (1.234 en lugar de 1,234) y hora de Guayaquil.
const TZ = "America/Guayaquil";

export const fmtNum = (n: number | null | undefined) => (n ?? 0).toLocaleString("es-EC");

export const plural = (n: number, one: string, many: string) => `${fmtNum(n)} ${n === 1 ? one : many}`;

export const fmtDate = (iso?: string | null) => {
  if (!iso) return "—";
  // Una fecha sin hora (2026-11-15) es un día del calendario: new Date la toma como medianoche UTC y en
  // Ecuador (UTC-5) se mostraría el día anterior.
  const dayOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso);
  const d = new Date(dayOnly ? `${iso}T00:00:00Z` : iso);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString("es-EC", { day: "numeric", month: "short", year: "numeric", timeZone: dayOnly ? "UTC" : TZ });
};

export const fmtDateTime = (iso?: string | null) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime())
    ? "—"
    : d.toLocaleString("es-EC", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: TZ });
};

// Búsqueda sin distinguir tildes ni mayúsculas: "jose" encuentra a "José".
export const norm = (s?: string | null) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Montos en dólares con dos decimales: $2,20 (formato de Ecuador).
export const fmtMoney = (n: number | null | undefined, currency?: string | null) =>
  n == null ? "—" : n.toLocaleString("es-EC", { style: "currency", currency: (currency || "usd").toUpperCase(), minimumFractionDigits: 2 });
